import React, { useMemo } from 'react';

import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';
import ErrorMessage from 'buyside/components/presentation/ErrorMessage/errorMessage';
import FormButtons from 'buyside/components/presentation/Form/FormButtons/formButtons';
import Icon from 'buyside/components/presentation/Icon/icon';
import Modal from 'buyside/components/presentation/Modal/modal';
import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';

import styles from 'buyside/components/presentation/Form/FormModal/formModalStyles.scss';

export const FormModal = ({
  isOpen,
  closeModal,
  modalId,
  icon,
  title,
  alertText,
  form: Form,
  isSumzeroAdmin,
  values,
  isSubmitting,
  errors,
  touched,
  status,
  handleSubmit,
  setFieldValue,
  resetForm,
  dirty
}) => {
  const handleCancel = () => {
    closeModal();
    resetForm();
  };
  const { serverError } = status || {};
  const hasErrors = !isSubmitting && !!Object.keys(errors).length && touched.submitDetector;

  const modalTitle = useMemo(
    () => (
      <>
        {icon ? <Icon type={icon} /> : null}
        {title}
      </>
    ),
    [icon, title]
  );

  return (
    <Modal
      id={modalId}
      isOpen={isOpen}
      onClose={closeModal}
      size={['Returns', 'Update Your Fund Returns'].includes(title) ? 'xl' : 'lg'}
      title={modalTitle}
    >
      {serverError && (
        <ErrorMessage title="Uh Oh...">
          There was a problem submitting the form. Please refresh the page. If the problem persists,
          contact support@sumzero.com.
        </ErrorMessage>
      )}
      <form onSubmit={handleSubmit}>
        <div id={modalId}>
          {alertText && (
            <div className={styles.formAlert}>
              <AlertStatic>
                <ParsedHtml html={'Instructions: ' + alertText}>
                  {({ content }) => <div>{content}</div>}
                </ParsedHtml>
              </AlertStatic>
            </div>
          )}
          <Form
            modalId={modalId}
            isSumzeroAdmin={isSumzeroAdmin}
            isSubmitting={isSubmitting}
            values={values}
            setFieldValue={setFieldValue}
          />
        </div>
        <FormButtons
          dirty={dirty}
          onCancel={handleCancel}
          isSubmitting={isSubmitting}
          hasErrors={hasErrors}
          hideSubmit={modalId === 'form_accredited_investor_profile'}
        />
      </form>
    </Modal>
  );
};

export default FormModal;
